module.exports = new __parcel__URL__("confluence-project-pages.86748246.png").toString();